/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Model } from '@app/shared/models/model.model';
import { IndustriesSeo } from '@app/settings/industries/industries-seo.model';

export class Industry extends Model {
  id: number;
  name: string;
  active: boolean;
  translations?: Array<IndustriesSeo>;

  get formattedName(): String {
    return this.name;
  }
}
